import { useMemo } from 'react';

export function useClassName(...classNames: string[] | string[][]): string {
  return useMemo(() => (classNames as any[])
    .filter(Boolean) // truthy
    .map((className: string | string[]) => Array.isArray(className) ? className.join(' ') : className)
    .join(' '),
  classNames);
}
